import { definitions } from '@luxuryescapes/contract-svc-promo';

import { PromoRequestWarn, getPromoRequestWarnings } from '~/services/PromoService';

export type PromoRequestWarningSummary = {
  promoRequest: definitions['PromoCodeRequest'];
  warning: PromoRequestWarn;
};

export type PromoRequestWarningSeverityCount = {
  severity: PromoRequestWarn['severity'];
  count: number;
};

const WARNING_SEVERITIES: Array<PromoRequestWarn['severity']> = ['error', 'warning', 'info'];

export function getPromoRequestWarningsSummary(
  promoRequests?: Array<definitions['PromoCodeRequest']>,
): Array<PromoRequestWarningSummary> {
  return (promoRequests ?? []).flatMap((promoRequest) =>
    getPromoRequestWarnings(promoRequest).map((warning) => ({ promoRequest, warning })),
  );
}

export function getPromoRequestWarningCountsBySeverity(
  warnings: Array<PromoRequestWarn>,
): Array<PromoRequestWarningSeverityCount> {
  return WARNING_SEVERITIES.flatMap((severity) => {
    const count = warnings.filter((warning) => warning.severity === severity).length;
    return count > 0 ? [{ severity, count }] : [];
  });
}
